<div class="web-view" >

    <div class="navbar-div" fxHide.xs fxHide.sm fxHide.lt-md>
        <app-web-navbar></app-web-navbar>
    </div>

    <div class="mobile-navbar" fxHide.lg fxHide.md fxHide.lt fxHide.gt-lg>
            <app-sidebar></app-sidebar>
    </div>


    <div class="main-div" fxLayout="row wrap" fxLayout.lt-md="column wrap">

        <div fxLayout="row" fxLayout.lt-md="column-reverse" style="justify-content: center; position: relative; right: 0; left: 0;">
            <div fxLayout="column wrap" class="description-div">
                <span [innerHTML]="homepage?.mainDescription">
                </span>
            </div>

            <div class="image-div" fxLayout="column wrap">

                <img class="image" [src]="mainImage" alt="Cinejoy Home Page Image" loading="eager" height="350" width="800">

            </div>
        </div>
        <div fxLayout="row wrap" class="button-main-div" fxLayoutGap="50px" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
            <div fxLayout="row wrap" fxLayout.lt-md="column wrap" class="button-div" fxLayoutAlign="start center"
                *ngFor="let btn of homepage?.topButtons">

                <a href="{{btn?.buttonUrl}}">
                    <button class="btn">
                        <span class="btn_effect">{{btn?.buttonName}}</span>
                    </button>
                </a>

            </div>
        </div>


    </div>


    <div class="spotlight-div event-div" *ngFor="let event of homepage?.eventList">
        <div *ngIf="event?.sequence%2!=0" fxLayout="row" fxLayout.lt-md="column">
            <a href="{{event?.eventurl}}">
                <div class="event-image-div" fxLayout="row">
                    <img class="event-image" [src]="getFileNameFromUrl(event?.eventImg)" alt="Spotlight Image" width="700" height="400">
                </div>
            </a>
            <div class="event-details-div" fxLayout="row wrap" fxLayoutAlign="start center">
                <p class="event-heading"><a href="{{event?.eventurl}}">
                        {{event?.eventTitle}}</a>
                </p>
                <p class="event-details">{{event?.eventDescription}}</p>
            </div>
        </div>

        <div *ngIf="event.sequence%2==0" fxLayout="row" fxLayout.lt-md="column-reverse">

            <div class="event-details-div" fxLayout="row wrap" fxLayoutAlign="start center">
                <p class="event-heading"><a href="{{event?.eventurl}}">
                        {{event?.eventTitle}}</a>
                </p>
                <p class="event-details">{{event?.eventDescription}}</p>
            </div>

            <a href="{{event?.eventurl}}">
                <div class="event-image-div" fxLayout="row">
                    <img class="event-image" [src]="getFileNameFromUrl(event?.eventImg)" alt="Spotlight Image" width="700" height="400">
                </div>
            </a>

        </div>

    </div>


    <div class="cinejoy-details-main-div" fxLayout="row wrap">

        <div class="cinejoy-details-div" fxLayout="row" fxLayoutAlign="start center">
            <p class="cinejoy-details">
                {{homepage?.cinejoyUpdate}}
            </p>
        </div>

        <div class="button-bottom-div" fxLayout="row wrap" fxLayoutGap="50px" fxLayoutGap.lt-md="10px" fxLayout.lt-md="column wrap">
            <div class="btn-div" fxLayout="row wrap" fxLayoutGap="50px" *ngFor="let btn of homepage?.bottomButtons" fxLayout.lt-md="column">

                <a href="{{btn?.buttonUrl}}">
                    <button class="btn"><span class="btn_effect">{{btn?.buttonName}}</span>
                    </button>
                </a>
            </div>
        </div>

    </div>


    <div class="footer-div" fxHide.xs fxHide.sm fxHide.lt-md>
        <app-cinejoy-footer></app-cinejoy-footer>
    </div>

    <div class="footer-div" fxHide.lg fxHide.md fxHide.lt fxHide.gt-lg>
        <app-cinejoy-mobile-footer></app-cinejoy-mobile-footer>
    </div>


</div>
<!-- wev view ended -->
